import { FechaFunctionsService } from '@/utils/functions.service';
import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { GeneralService } from '@services/general.service';
import { LoadingService } from '@services/loading.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-cliente',
  templateUrl: './cliente.component.html',
  styleUrls: ['./cliente.component.scss']
})
export class ClienteComponent {
  cliente: any = null
  idCliente: number
  mapa: any
  pedidos: Array<any> = []
  isLoading: boolean = false
  isExpanded = {};

  constructor(private router: Router,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public generalService: GeneralService,
    public Func: FechaFunctionsService,
    public loadingService: LoadingService,
    protected sanitizer: DomSanitizer) {
  }

  async ngOnInit() {
    await this.initializeForm();
    this.loadingService.setLoading(false);
  }

  onlyNumber(e: any) {
    const regExp = /[^0-9]+/g;
    e.target.value = e.target.value.replace(regExp, '');
  }

  async initializeForm() {
    if (localStorage.getItem('idCliente')) {
      this.idCliente = Number(localStorage.getItem('idCliente'));
      await this.getCliente(this.idCliente)
      await this.getData(this.idCliente)
    }
  }

  async getCliente(idCliente) {
    try {
      let res = await this.generalService.getObtiene("cliente", idCliente)
      this.cliente = res.data;
    } catch (error) {
      this.cliente = null
    }
  }

  async getData(idCliente) {
    try {
      this.isLoading = true
      let res = await this.generalService.getObtiene(`pedido/cliente`, idCliente)
      this.pedidos = res.data;
      this.isLoading = false
    } catch (error) {
      this.pedidos = [];
      this.isLoading = false
    }
  }

  openDetail(rowIndex, item) {
    this.cliente.direccions.forEach((e, i) => {
      if (i != rowIndex) {
        this.isExpanded[i] = false
      }
    })
    this.isExpanded[rowIndex] = !this.isExpanded[rowIndex]
    this.mapa = this.sanitizer.bypassSecurityTrustResourceUrl(`https://maps.google.com/maps?q=${item.direccion},+${item.comuna_nombre},+${item.provincia_nombre},+${item.region_nombre}&t=&z=15&ie=UTF8&iwloc=&output=embed`);
  }
}
